export enum SelectTypes {
  SELECTED_COMPANY = 'selectedCompany',
  SELECTED_PROJECT = 'selectedProject',
}
